import { IReassigmentProvider } from '../../interfaces/service/ReassignmentServiceManagerInterface';
import { getActionsTemplate } from './components/table/BodyTemplatesTable';

export const samDataTableColumns = [
  {
    field: 'SamId',
    header: 'SAM ID',
    sortable: true,
    style: { flexGrow: 1, flexBasis: '100px' },
    filter: true,
  },
  {
    field: 'SamTypeName',
    header: 'Tipo de SAM',
    style: { flexGrow: 1, flexBasis: '100px' },
    sortable: true,
    filter: true,
  },
  {
    field: 'DetachedDate',
    header: 'Fecha Liberación',
    style: { flexGrow: 1, flexBasis: '100px' },
    sortable: true,
    filter: true,
  },
  {
    field: 'DetachedNotes',
    header: 'Comentario Liberación',
    style: { flexGrow: 1, flexBasis: '100px' },
    sortable: true,
    filter: true,
  },
];

export const deviceDataTableColumns = [
  {
    field: 'DeviceTypeName',
    header: 'Equipo',
    sortable: true,
    style: { flexGrow: 1, flexBasis: '100px' },
    filter: true,
  },
  {
    field: 'StationName',
    header: 'Estación',
    sortable: true,
    style: { flexGrow: 1, flexBasis: '100px' },
    filter: true,
  },
  {
    field: 'LocationName',
    header: 'Locación',
    style: { flexGrow: 1, flexBasis: '100px' },
    sortable: true,
    filter: true,
  },
  {
    field: 'ProjectName',
    header: 'Proyecto',
    style: { flexGrow: 1, flexBasis: '100px' },
    sortable: true,
    filter: true,
  },
  {
    field: 'RouteName',
    header: 'Ruta',
    style: { flexGrow: 1, flexBasis: '100px' },
    sortable: true,
    filter: true,
  },
  {
    field: 'EconomicNumber',
    header: 'Número económico',
    style: { flexGrow: 1, flexBasis: '100px' },
    sortable: true,
    filter: true,
  },
  {
    field: 'PcModuleName',
    header: 'Módulo PC',
    style: { flexGrow: 1, flexBasis: '100px' },
    sortable: true,
    filter: true,
  },
  {
    field: 'DeviceNumber',
    header: 'Id Lector',
    sortable: true,
    style: { flexGrow: 1, flexBasis: '100px' },
    filter: true,
  },
  {
    field: 'Notes',
    header: 'Comentario Liberación',
    sortable: true,
    style: { flexGrow: 1, flexBasis: '100px' },
    filter: true,
  },
];

export function createColumnsTable(
  service: IReassigmentProvider,
  columnsFilter: boolean = false
) {
  const baseColumns =
    service.radioSelection === 'SAM'
      ? samDataTableColumns
      : deviceDataTableColumns;

  const actionColumn = {
    field: 'reassign',
    header: 'Acción',
    style: { flexGrow: 1, flexBasis: '100px' },
    sortable: false,
    isFilter: false,
    body: getActionsTemplate(service.reassignHandler),
  };

  // const allColumns = [...baseColumns, actionColumn];

  const _filteredColumns = baseColumns.filter(col =>
    service.columnsSelected.some(selected => selected.field === col.field)
  );
  const filteredColumns = columnsFilter
    ? _filteredColumns
    : [..._filteredColumns, actionColumn];
  return filteredColumns;
}
